import { Input } from '@angular/core';
import { Subscriber } from 'rxjs/Subscriber';
import { IStore, IPremises, IContract, ContractStatus, IChangeCallback, IIdNameGeneric} from '../../_entities';
import { IDataAccessEvent, IDataChangeCallback } from "../../_entities/data";
import { ContractService } from "../../_services";
import * as moment from 'moment';
import { StringTool } from "../../core/tools/index";

export class ContractBase {

	@Input() contract: IContract;
	@Input() store: IStore;
	@Input() premises: IPremises;


	@Input() disabled: boolean = false;

	nullValue = null;
	contractChangedSubscription: Subscriber<IDataAccessEvent<IContract>>;

	ifrsDates: IIdNameGeneric<string>[] = [];


	constructor(protected readonly contractService: ContractService) {

		Array.from(Array(40).keys()).map(i => 1999 + i).forEach(year =>
			Array.from(Array(12).keys()).map(i => 1 + i).forEach(month => {
					this.ifrsDates.push({
						id: `${year}-${StringTool.padZero(month, 2)}-01`,
						name: moment(`${year}-${StringTool.padZero(month, 2)}-01`, 'YYYY-MM-DD').format("MMM-YY")
					});
				}
			));


		this.contractChangedSubscription = this.contractService.itemChanged.subscribe((evt: IDataAccessEvent<IContract>) => {
			this.contract = evt.data;

		});
	}

	get title(): string {
		const contract = this.contract;
		if (contract == null) return "";
		return contract.contractTypeName != null ? `${contract.contractCode} (${contract.contractTypeName.toLowerCase()} contract)` : contract.contractCode;
	}

	onAdd(event: IChangeCallback<any>) {
		const storeId = this.store.id;
		const contract: any = {
			storeId: storeId,
			contractStatusId: ContractStatus.Draft as number
		};
		this.contractService.addItem(contract).then((newContract) => {
			event.resolve();
		}).catch((err) => {
			event.reject(err);
		});
	}

	onChange(contract: IContract, event: IDataChangeCallback<any> | IChangeCallback<any>) {
		const fieldname = this.contractService.isDataChangeCallback(event) ? event.fieldname : event.id;
		const patches = [
			{ "op": "replace", "path": `/${fieldname}`, "value": event.newValue }
		];

		this.contractService.patchItem(contract.id, patches, event.oldValue).then((updatedContract) => {
			event.resolve();
			this.contract = updatedContract;
		}).catch((err) => {
			event.reject(err);
		});

	}

	onDelete(event: IChangeCallback<any>) {
		this.contractService.deleteItem(event.id)
			.then(() => {
				event.resolve();
			})
			.catch((err) => { console.log(err); });;
	}



}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract.base.ts